import PropTypes from 'prop-types'

import AdviceStepChat from './AdviceStepChat'
import { OverlaySheet } from './styled'

/*
 * Mobile: the chatbot opens as a sheet over the step, from the in-page AI comment
 * (AdviceHeyNicComment). Same chat as the desktop panel — fixed header and
 * footer, only the transcript scrolls — sized to the screen instead of a card.
 *
 * Tapping the X is the only way out; there is no scrim to tap, matching the
 * design's full-bleed sheet.
 */
const AdviceHeyNicOverlay = ({ open, stepPath, stepLabel, showInput, onClose, onCaseRefresh }) => {
  if (!open) return null

  return (
    <OverlaySheet role='dialog' aria-modal='true' aria-label='Hey Nic'>
      <AdviceStepChat
        stepPath={stepPath}
        stepLabel={stepLabel}
        showInput={showInput}
        onClose={onClose}
        onCaseRefresh={onCaseRefresh}
      />
    </OverlaySheet>
  )
}

AdviceHeyNicOverlay.propTypes = {
  open: PropTypes.bool,
  stepPath: PropTypes.string.isRequired,
  stepLabel: PropTypes.string,
  /** Show the free-text field (summary step only). */
  showInput: PropTypes.bool,
  onClose: PropTypes.func.isRequired,
  onCaseRefresh: PropTypes.func,
}

export default AdviceHeyNicOverlay
